import ProjectDashboard from "./ProjectDashboard";

export default  function ProjectIcDetails({projectId,imageGenerationTimestamp}){

    return <div>
        <ProjectDashboard projectId={projectId} imageGenerationTimestamp={imageGenerationTimestamp}/>
    </div>
}